<template>
    <div>
        <div class="head">
            <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager'}">全流程安全生产</el-breadcrumb-item>
                <el-breadcrumb-item>巡检管理</el-breadcrumb-item>
                <el-breadcrumb-item>巡检路线</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="content">
            <div style="display: flex;width: 100%;justify-content: space-between;">
                <Button type="primary" @click="handleAdd()">新建</Button>
                <Input search enter-button placeholder=" 请输入名称/编号" v-model="fileNameOrTag" @on-search="getRouteList(1)"
                       style="width: 300px"/>
            </div>
            <div style="margin-top: 20px;">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="serialNumber" style="width: 200px" label="编号"></el-table-column>
                    <el-table-column prop="name" label="名称"></el-table-column>

                    <el-table-column prop="remark" label="描述" width="200"></el-table-column>
                    <el-table-column prop="duration" label="持续时间"></el-table-column>
                    <el-table-column prop="userVos" label="巡检人" width="200">
                        <template slot-scope="scope">
                            <el-tag v-for="(item1,index) in scope.row.userVos" type="info">{{item1.nickname}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="gmtCreate" label="创建时间"></el-table-column>
                    <el-table-column prop="oper" label="操作" width="180">
                        <template slot-scope="scope">
                            <el-popover >
                                <div slot="reference" class="name-wrapper">
                                    <el-link type="primary" @click="handChange(scope.row.id,scope.row)">编辑</el-link>
                                    |
                                    <el-link type="danger" @click="handleDel(scope.row)">删除</el-link>
                                </div>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页 -->
                <Page style="float: right;margin-top: 10px;" :total="total" :page-size="pageSize"
                      @on-change="getRouteList" :current="currentPage" />
            </div>

        </div>
    </div>
</template>

<script>
    import {getList, postInfo} from "../process/api/http";

    export default {
        data() {
            return {
                userVos: [],
                options: [],
                total: 10,
                sizePage: 10,
                currentPage: 1,
                tableData: [],
                fileNameOrTag:'',
                pageSize: 10,
            };
        },
        created() {
            this.getRouteList(1);
        },
        methods: {
            handleSizeChange(val) {
                this.sizePage = val;
                this.getRouteList(this.currentPage, this.sizePage);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getRouteList(this.currentPage, this.sizePage);
            },
            getRouteList(page) {
              this.currentPage = page
                let param = {};
                param.limit = this.pageSize;
                param.curPage = page;
                param.name = this.fileNameOrTag;
                this.componentsMoudel.httpRequest
                    .getRequestHander("/inspectionroute/list_all")
                    .openLoad()
                    .startPost(param)
                    .then((res) => {
                        this.tableData = res.body.data;
                        // this.currentPage = res.body.page;
                        this.total = res.body.cum;
                        this.pageTotal = res.body.pageTotal;
                    });
            },
            handleAdd() {
                this.$router.push({
                    path: "addInsPath",
                });
            },
            handChange(id, row) {
                this.$router.push({
                    name: "addInsPath",
                    params: {key: row},
                });
            },
            handleDel(row) {
              this.$confirm(`删除路线 "${row.name}", 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.componentsMoudel.httpRequest
                  .getRequestHander("/inspectionroute/delete/"+row.id)
                  .openLoad()
                  .startDel()
                  .then((res) => {
                    if(this.tableData.length <= 1 && this.currentPage > 1) {
                      this.currentPage -= 1
                    }
                    this.getRouteList(this.currentPage);
                    this.$message.success('删除成功')
                  });
              }).catch(() => {
                return         
              });
            },
        },
    };
</script>

<style scoped>
    .myHead {
        position: absolute;
        top: 0px;
        left: 250px;
        width: 80%;
        height: 60px;
    }

    .addBtn {
        position: absolute;
        top: 10px;
        right: 10px;
    }
</style>
